import React from "react";

interface NotificationMessageProps {
    message: string;
    patientName?: string;
    // Invoked when the patient name inside the message is clicked.
    onOpenPatient: () => void;
}

// Renders the backend-formatted (RTL) message as-is, but when `patientName`
// appears inside it, that occurrence is turned into an underlined, clickable
// link that opens the patient page. Falls back to plain text when there is no
// name or the name is not present in the message.
export const NotificationMessage: React.FC<NotificationMessageProps> = ({
    message,
    patientName,
    onOpenPatient,
}) => {
    const name = patientName?.trim();
    if (!name || !message.includes(name)) {
        return <>{message}</>;
    }

    const parts = message.split(name);
    return (
        <>
            {parts.map((part, i) => (
                <React.Fragment key={i}>
                    {part}
                    {i < parts.length - 1 && (
                        <span
                            onClick={(e) => {
                                e.stopPropagation();
                                onOpenPatient();
                            }}
                            style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                color: "#3b5d6b",
                                fontWeight: 600,
                            }}
                        >
                            {name}
                        </span>
                    )}
                </React.Fragment>
            ))}
        </>
    );
};
